import { generateDiffFile } from '@git-diff-view/file'

import { toText } from './toText'

/**
 * Added and removed line counts for the same diff `DiffViewer` renders.
 *
 * Imports only `@git-diff-view/file` — the diff engine — and not the React
 * package with its stylesheet, the same carve-out `toText` exists for. Going
 * through the library rather than a hand-rolled line diff is what stops a
 * `+2 -1` badge disagreeing with the hunks printed underneath it.
 */
export function diffStats(
  oldValue: unknown,
  newValue: unknown
): { added: number; removed: number } {
  try {
    // (oldName, oldContent, newName, newContent, oldLang, newLang) — empty
    // langs because syntax highlighting is off, matching DiffViewer.
    const file = generateDiffFile(
      'value',
      toText(oldValue),
      'value',
      toText(newValue),
      '',
      ''
    )
    file.init()
    return { added: file.additionLength, removed: file.deletionLength }
  } catch {
    // The badge is a summary; a diff the library cannot build is one the
    // viewer below will report on its own.
    return { added: 0, removed: 0 }
  }
}
